import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listLabs } from "../../Redux/actions/patientActions/labActions.js";
import Loading from "../../components/Loading.jsx";
import Error from "../../components/Error.jsx";

const LabReportsScreen = () => {
  const dispatch = useDispatch();
  const { loading, error, labs } = useSelector((state) => state.labs);

  useEffect(() => {
    dispatch(listLabs());
  }, [dispatch]);

  return (
    <div className="container mt-4">
      <h2>Lab Reports</h2>
      {loading && <Loading />}
      {error && <Error message={error} />}
      <table className="table table-striped mt-3">
        <thead>
          <tr>
            <th>Patient</th>
            <th>Doctor</th>
            <th>Test Name</th>
            <th>Result</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {labs && labs.map((lab) => (
            <tr key={lab._id}>
              <td>{lab.patient.name}</td>
              <td>{lab.doctor.name}</td>
              <td>{lab.testName}</td>
              <td>{lab.result}</td>
              <td>{new Date(lab.date).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LabReportsScreen;
